import { useState } from 'react'
import { filterAdjustmentsPromoDiscount } from 'helpers/cart'
import {
  useTemporaryOrderWithPromotionQuery,
  TemporaryOrderWithPromotionQuery,
  OrderLineItemInput,
} from 'graphQL/dinein/generate/operations'
import { dineInClient } from 'variables/services'

interface useSummaryOrderPrivateCartProps {
  tableID: number
  lineItems: OrderLineItemInput[]
}

interface SummaryPrivateCartType {
  lineItemTotalSatangs: TemporaryOrderWithPromotionQuery['temporaryOrderWithPromotion']['lineItemTotalSatangs']
  adjustments: TemporaryOrderWithPromotionQuery['temporaryOrderWithPromotion']['adjustments']
  totalSatangs: TemporaryOrderWithPromotionQuery['temporaryOrderWithPromotion']['totalSatangs']
}

const useSummaryOrderPrivateCart = ({ tableID, lineItems }: useSummaryOrderPrivateCartProps) => {
  const [isHavePromoDiscount, setIsHavePromoDiscount] = useState<boolean>(false)
  const [summaryPrivateCart, setSummaryPrivateCart] = useState<SummaryPrivateCartType | null>(null)

  useTemporaryOrderWithPromotionQuery({
    client: dineInClient,
    variables: {
      tableID,
      lineItems,
    },
    skip: !tableID || !lineItems.length,
    onCompleted: (res) => {
      const temporaryOrderWithPromotion = res.temporaryOrderWithPromotion
      const { lineItemTotalSatangs, adjustments, totalSatangs } = temporaryOrderWithPromotion
      const _adjustments = filterAdjustmentsPromoDiscount(adjustments)
      setSummaryPrivateCart({
        lineItemTotalSatangs,
        adjustments: _adjustments,
        totalSatangs,
      })

      const _isHavePromoDiscount = _adjustments.length > 0 ? true : false
      setIsHavePromoDiscount(_isHavePromoDiscount)
    },
  })

  return {
    isHavePromoDiscount,
    summaryPrivateCart,
  }
}

export default useSummaryOrderPrivateCart
